import { render, staticRenderFns } from "./AssignToAdmin.vue?vue&type=template&id=3e6c8bb5&scoped=true&"
import script from "./AssignToAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AssignToAdmin.vue?vue&type=style&index=0&id=3e6c8bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c8bb5",
  null
  
)

export default component.exports